import React from 'react';
import { Spinner } from './Spinner';

interface VersionInfoProps {
    isLoading: boolean;
    versions: {
        fe: { version?: string; commit?: string; error?: string };
        be: { version?: string; commit?: string; error?: string };
    };
}

const VersionRow: React.FC<{ label: string; data: any }> = ({ label, data }) => (
    <div className="flex justify-between items-center py-2 border-b border-gray-200">
        <span className="text-sm font-medium text-gray-600">{label}</span>
        {data ? (
            data.error ? (
                 <span className="text-sm text-red-500">{data.error}</span>
            ) : (
                <span className="text-sm text-gray-800 font-mono bg-gray-100 px-2 py-1 rounded">
                    {data.version || 'N/A'} ({data.commit || 'N/A'})
                </span>
            )
        ) : (
            <span className="text-sm text-gray-500">Načítání...</span>
        )}
    </div>
);

export const VersionInfo: React.FC<VersionInfoProps> = ({ isLoading, versions }) => {
    return (
        <div className="bg-white p-6 rounded-lg shadow">
            <h3 className="text-xl font-semibold text-gray-700 mb-4">Informace o verzi</h3>
            {isLoading ? (
                <div className="flex justify-center items-center py-4">
                    <Spinner text="Načítám informace o verzích..." />
                </div>
            ) : (
                <div className="space-y-2">
                   <VersionRow label="Verze frontendu" data={versions.fe} />
                   <VersionRow label="Verze backendu" data={versions.be} />
                </div>
            )}
             <p className="text-xs text-gray-500 mt-4">
                Verze je automaticky aktualizována z Git commitu během sestavení (build) Docker obrazu.
            </p>
        </div>
    );
};
